import {observer} from 'mobx-react-lite'
import * as React from 'react'
import {useRef} from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {
  StoreContext,
  useStore
} from '@components/chat/chat-subscribers-chooser/chat-subscribers-chooser-store'
import {DropdownContent} from '@components/common/dropdown/dropdown-content'
import {Icon} from '@components/common/icon/icon'
import {UsersTable} from '@components/common/users-table/users-table'
import {Menu} from '@components/menu'
import {rightPanelStore} from '@components/right-panel/right-panel'
import {useClickAway} from '@containers/hooks'

export const TwToggleButton = tw.div`
    cursor-pointer
    text-12
    leading-6
    icon-container
    inline-flex
    text-obscure-old
    hover:text-action-hover
    hover:underline
`

const TwMenuOverlay = tw.div`
    h-screen
    bg-menu-active-element-old
    absolute
    text-14
    left-0
    opacity-50
    bottom-0
    right-0
`
const TwMenuContainer = tw.div`
    absolute
    select-none
    text-14
    left-0
    bottom-0
    right-0
    border-0
    border-t
    border-solid
    border-main-old
`
export const SubscribersMenu = observer(() => {
  const [state, store] = useStore()
  const chatWidth = rightPanelStore.state.chatPanel.width
  const ref = useRef<HTMLDivElement | null>(null)
  useClickAway(ref, store.toggleOpen)
  return state.open ? (
    <Menu onEscape={store.toggleOpen}>
      <StoreContext.Provider value={store}>
        <TwMenuOverlay
          style={{width: `${chatWidth}px`, zIndex: 51}}
          onClick={() => store.toggleOpen()}
        />
        <TwMenuContainer
          ref={ref}
          style={{width: `${chatWidth}px`, zIndex: 52}}
        >
          <DropdownContent
            header={
              <>
                <span>{Lang.msg.subscribedToTask}:</span>
                <Icon
                  className="-mr-4 cursor-pointer"
                  name="main-menu-close"
                  onClick={() => store.toggleOpen()}
                />
              </>
            }
          >
            <div className="text-secondary-old">
              {state.isPrivate ? <PrivateMenu /> : <PublicMenu />}
            </div>
          </DropdownContent>
        </TwMenuContainer>
      </StoreContext.Provider>
    </Menu>
  ) : null
})

const PublicMenu = observer(() => {
  const [state, store] = useStore()
  return (
    <UsersTable
      users={store.users}
      showPositionColumn={true}
      className="h-256"
      useCheckbox={true}
      selected={[...state.chosen]}
      onToggled={ids => store.toggleSubscriber(ids)}
    />
  )
})

const TwAction = tw.div`
    text-action-default
    inline-block
    text-12
    cursor-pointer
    hover:underline
`

const TwPrivateMenuContent = tw.div`
    py-16
    px-8
    mx-auto
    leading-5
    text-center
    max-w-380
`
const PrivateMenu = observer(() => {
  const [state, store] = useStore()
  return (
    <TwPrivateMenuContent>
      {state.isFromPrivateList && (
        <>{Lang.msg.chat.privateChatFromPrivateListSubscribers}</>
      )}
      {!state.isFromPrivateList && (
        <>
          {Lang.msg.chat.privateChatSubscribers}
          <TwAction onClick={() => store.makePublic()}>
            {Lang.msg.chat.makePublic}
          </TwAction>
        </>
      )}
    </TwPrivateMenuContent>
  )
})
